import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrderPaymentInboundComponent } from 'src/app/pages/orders/inbound/components/modals/order-payment-inbound/order-payment-inbound.component';
import { OrderPaymentComponent } from 'src/app/pages/orders/outbound/components/modals/order-payment/order-payment.component';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { AuthenticationService } from 'src/app/shared/services';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-quotation-value-modal',
  templateUrl: './quotation-confirm-modal.component.html',
  styleUrls: ['./quotation-confirm-modal.component.scss'],
})
export class QuotationConfirmModalComponent implements OnInit {
  boobleModalData: any;
  loading: boolean;
  private readonly notifier: NotifierService;
  isMobile: boolean;

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;
  @ViewChild('bottomSheetContentPayment')
  bottomSheetContentPayment: TemplateRef<any>;

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly orderService: OrdersService,
    private readonly accountService: AuthenticationService,
    private bottomSheet: MatBottomSheet
  ) {
    this.notifier = notifierService;
  }

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820;
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }

  confirm() {
    this.loading = true;
    this.orderService
      .createQuotation(
        this.boobleModalData.orderId,
        this.boobleModalData.quotationData
      )
      .subscribe({
        next: (quotationResult) => {
          this.boobleModalData.order = quotationResult.data;
          this.boobleModalData.order.remmitanceType == 'INBOUND'
            ? this.openOrderPaymentInboundModal(this.boobleModalData.order)
            : this.openOrderPaymentModal(this.boobleModalData.order);
          this.orderService.updateOrderView();
          this.notifier.notify('success', 'Câmbio fechado com sucesso!');
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  openOrderPaymentModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.modalService.dismiss(null);
      this.openBottomSheet();
    } else {
      this.modalService.present(OrderPaymentComponent, order);
    }
  }

  openOrderPaymentInboundModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.modalService.dismiss(null);
      this.bottomSheet.open(GenericBottomSheetComponent, {
        data: { content: this.bottomSheetContentPayment },
      });
    } else {
      this.modalService.dismiss(null);
      this.modalService.present(OrderPaymentInboundComponent, order);
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }
}
